import React from "react";

const SpeechBubbleIcon: React.FC<{ className?: string; size?: number }> = ({ className = "", size = 40 }) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="19.4444" fill="white" stroke="#EDEBEC" strokeWidth="1.11111" />
      <g transform="translate(0, 0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.2787 22.8935C25.9534 22.8935 26.5197 23.4504 26.4166 24.1167C25.8113 28.0367 22.4555 30.9472 18.4081 30.9472C13.9302 30.9472 10.3008 27.3177 10.3008 22.8409C10.3008 19.1525 13.1029 15.7167 16.2576 14.9398C16.9355 14.7725 17.6302 15.2493 17.6302 15.9472C17.6302 20.6756 17.7892 21.8988 18.6871 22.5641C19.585 23.2293 20.6408 22.8935 25.2787 22.8935Z"
          stroke="#0069AD"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.6941 18.9532C29.7478 15.9153 26.0162 11.0184 21.4688 11.1026C21.1151 11.109 20.832 11.4037 20.8162 11.7563C20.7015 14.2542 20.8562 17.4911 20.9425 18.9584C20.9688 19.4153 21.3278 19.7742 21.7836 19.8005C23.292 19.8868 26.6467 20.0047 29.1088 19.6321C29.4436 19.5816 29.6888 19.2911 29.6941 18.9532Z"
          fill="#BBD8ED"
          stroke="#00A7E4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default SpeechBubbleIcon;